<template>
  <v-container fluid>
    <v-row>
      <v-col cols="2">
        <v-btn @click="showAddDialog = true" class="ml-3"><v-icon>mdi-plus-thick</v-icon></v-btn>
        <v-btn @click="isGrid=true" class="ml-3"><v-icon>mdi-widgets-outline</v-icon></v-btn>
        <v-btn @click="isGrid=false" class="ml-3"><v-icon>mdi-format-list-bulleted-square</v-icon></v-btn>
      </v-col>
      <v-col cols="8"><div class="text-h4 text-center">Your Post Watches</div> </v-col>
      <v-col cols="2">
        <div class="d-flex justify-end">

        </div>
      </v-col>
    </v-row>
   <PostWatchGrid :post-watches="postWatches" v-if="isGrid" @update-watch="onWatchUpdate($event)" @delete-watch="deleteWatch($event)" v-on="$listeners"></PostWatchGrid>
    <PostWatchList :post-watches="postWatches" v-else @update-watch="onWatchUpdate($event)" v-on="$listeners"></PostWatchList>

    <div class="text-center">
      <v-dialog
          v-model="showAddDialog"
          width="500"
      >

        <v-card>
          <v-card-title class="headline">
            Add Post Watch
          </v-card-title>

          <v-card-text>
            <v-text-field
                label="Reddit URL / Post ID"
                placeholder="https://redd.it/xyz"
                outlined
                v-model="newWatchId"
                @change="updateNewWatchId"
                class="mt-6"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="createPostWatch"
            >
              Add Watch
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>

</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import {filterMixins} from "@/util/mixins/filterMixin";
import PostWatchGrid from "@/components/watch/PostWatchGrid";
import PostWatchList from "@/components/watch/PostWatchList";
import moment from "moment";
import {getPostIdFromUrl} from "@/util/helpers";
const WatchRepo = RepositoryFactory.get('watch')
export default {
  name: "PostWatches",
  components: {PostWatchList, PostWatchGrid},
  mixins: [filterMixins],
  data: () => ({
    postWatches: [],
    confirmDelete: false,
    isGrid: true,
    showAddDialog: false,
    newWatchId: null
  }),
  methods: {
    deleteWatch(watch) {
      WatchRepo.deletePostWatch({params: {watch_id: watch.id, token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          this.$emit('on-alert', {color: 'success', message: 'Watch has been deleted'})
          this.getWatches();
        })

    },
    onWatchUpdate(item) {
      console.log('Watch update event handler')
      console.log(item)
      WatchRepo.updatePostWatch(item, {params: {token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          this.$emit('on-alert', {color: 'success', message: 'Watch has been updated'})
        })
    },
    getWatches: function() {
      WatchRepo.getPostWatches(this.$store.getters.username, {params: {token: this.$store.getters.token}})
        .then(results => {
          if (results.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: results.data})
            return;
          }
          results.data.forEach(item => {
            item.watch.created_at = moment.unix(item.watch.created_at).format('YYYY-MM-DD HH:MM:SS');
            item.watch.last_detection = item.watch.last_detection ? moment.unix(item.watch.last_detection).format('YYYY-MM-DD HH:MM:SS') : null;
          })
          this.postWatches = results.data
        })
    },
    updateNewWatchId() {
      this.newWatchId = getPostIdFromUrl(this.newWatchId)
      if (!this.newWatchId) {
        this.$emit('on-alert', {color: 'error', message: 'Unable to parse Post ID from provided URL'})
      }
    },
    createPostWatch() {
      WatchRepo.createPostWatch({post_id: this.newWatchId, enabled: true}, {params: {token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data});
            return;
          }
          this.$emit('on-alert', {color: 'success', message: `Created watch for post ${this.newWatchId}`});
          this.getWatches();
        })
    }
  },
  mounted() {
    this.getWatches();
  },
  computed: {

  }
}
</script>

<style scoped>
.content:before {
  content: "";


  z-index: -1;

  display: block;
  ;
  opacity: .5;
  width: 100%;
  height: 100%;

  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(10px);
  overflow: hidden;
}

.content {


  z-index: 0;

}
</style>